"use strict";

exports.__esModule = true;
var _IFrameElement = require("./IFrameElement");
Object.keys(_IFrameElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _IFrameElement[key]) return;
  exports[key] = _IFrameElement[key];
});
var _EditableIFrameElement = require("./EditableIFrameElement");
Object.keys(_EditableIFrameElement).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _EditableIFrameElement[key]) return;
  exports[key] = _EditableIFrameElement[key];
});
var _IFrameThumbnail = require("./IFrameThumbnail");
Object.keys(_IFrameThumbnail).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _IFrameThumbnail[key]) return;
  exports[key] = _IFrameThumbnail[key];
});
var _IFrameFields = require("./IFrameFields");
Object.keys(_IFrameFields).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _IFrameFields[key]) return;
  exports[key] = _IFrameFields[key];
});
var _IFrameHeader = require("./IFrameHeader");
Object.keys(_IFrameHeader).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _IFrameHeader[key]) return;
  exports[key] = _IFrameHeader[key];
});
var _widget = require("./widget");
Object.keys(_widget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _widget[key]) return;
  exports[key] = _widget[key];
});